/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataJobEnum } from './DataJobEnum';
import { DataJobEnumFromJSON, DataJobEnumFromJSONTyped, DataJobEnumToJSON } from './DataJobEnum';
import type { DatasetPipelineStatus } from './DatasetPipelineStatus';
import {
  DatasetPipelineStatusFromJSON,
  DatasetPipelineStatusFromJSONTyped,
  DatasetPipelineStatusToJSON,
} from './DatasetPipelineStatus';
import type { AiModelName } from './AiModelName';
import { AiModelNameFromJSON, AiModelNameFromJSONTyped, AiModelNameToJSON } from './AiModelName';
import type { DatasetPipelineInferencer } from './DatasetPipelineInferencer';
import {
  DatasetPipelineInferencerFromJSON,
  DatasetPipelineInferencerFromJSONTyped,
  DatasetPipelineInferencerToJSON,
} from './DatasetPipelineInferencer';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface DatasetPipeline
 */
export interface DatasetPipeline {
  /**
   *
   * @type {number}
   * @memberof DatasetPipeline
   */
  readonly id: number;
  /**
   *
   * @type {AiModelName}
   * @memberof DatasetPipeline
   */
  readonly aiModel: AiModelName;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof DatasetPipeline
   */
  taskType?: TaskTypeEnum | null;
  /**
   *
   * @type {number}
   * @memberof DatasetPipeline
   */
  generationInputs?: number | null;
  /**
   *
   * @type {DatasetPipelineInferencer}
   * @memberof DatasetPipeline
   */
  inferencer: DatasetPipelineInferencer;
  /**
   *
   * @type {Array<Perturbation>}
   * @memberof DatasetPipeline
   */
  readonly perturbations: Array<Perturbation>;
  /**
   *
   * @type {number}
   * @memberof DatasetPipeline
   */
  dataset?: number | null;
  /**
   *
   * @type {Array<number>}
   * @memberof DatasetPipeline
   */
  readonly perturbedDatasets: Array<number>;
  /**
   *
   * @type {string}
   * @memberof DatasetPipeline
   */
  taskName?: string | null;
  /**
   *
   * @type {number}
   * @memberof DatasetPipeline
   */
  readonly progress: number | null;
  /**
   *
   * @type {Date}
   * @memberof DatasetPipeline
   */
  readonly startTime: Date | null;
  /**
   *
   * @type {Date}
   * @memberof DatasetPipeline
   */
  readonly endTime: Date | null;
  /**
   *
   * @type {number}
   * @memberof DatasetPipeline
   */
  readonly estimatedTime: number | null;
  /**
   *
   * @type {string}
   * @memberof DatasetPipeline
   */
  readonly errorMessage: string | null;
  /**
   *
   * @type {DataJobEnum}
   * @memberof DatasetPipeline
   */
  readonly dataJob: DataJobEnum | null;
  /**
   *
   * @type {DatasetPipelineStatus}
   * @memberof DatasetPipeline
   */
  readonly status: DatasetPipelineStatus | null;
  /**
   *
   * @type {Date}
   * @memberof DatasetPipeline
   */
  readonly timestamp: Date;
}

/**
 * Check if a given object implements the DatasetPipeline interface.
 */
export function instanceOfDatasetPipeline(value: object): value is DatasetPipeline {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  if (!('inferencer' in value) || value['inferencer'] === undefined) return false;
  if (!('perturbations' in value) || value['perturbations'] === undefined) return false;
  if (!('perturbedDatasets' in value) || value['perturbedDatasets'] === undefined) return false;
  if (!('progress' in value) || value['progress'] === undefined) return false;
  if (!('startTime' in value) || value['startTime'] === undefined) return false;
  if (!('endTime' in value) || value['endTime'] === undefined) return false;
  if (!('estimatedTime' in value) || value['estimatedTime'] === undefined) return false;
  if (!('errorMessage' in value) || value['errorMessage'] === undefined) return false;
  if (!('dataJob' in value) || value['dataJob'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  return true;
}

export function DatasetPipelineFromJSON(json: any): DatasetPipeline {
  return DatasetPipelineFromJSONTyped(json, false);
}

export function DatasetPipelineFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetPipeline {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    aiModel: AiModelNameFromJSON(json['ai_model']),
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    generationInputs: json['generation_inputs'] == null ? undefined : json['generation_inputs'],
    inferencer: DatasetPipelineInferencerFromJSON(json['inferencer']),
    perturbations: (json['perturbations'] as Array<any>).map(PerturbationFromJSON),
    dataset: json['dataset'] == null ? undefined : json['dataset'],
    perturbedDatasets: json['perturbed_datasets'],
    taskName: json['task_name'] == null ? undefined : json['task_name'],
    progress: json['progress'],
    startTime: json['start_time'] == null ? null : new Date(json['start_time']),
    endTime: json['end_time'] == null ? null : new Date(json['end_time']),
    estimatedTime: json['estimated_time'],
    errorMessage: json['error_message'],
    dataJob: DataJobEnumFromJSON(json['data_job']),
    status: DatasetPipelineStatusFromJSON(json['status']),
    timestamp: new Date(json['timestamp']),
  };
}

export function DatasetPipelineToJSON(
  value?: Omit<
    DatasetPipeline,
    | 'id'
    | 'aiModel'
    | 'perturbations'
    | 'perturbedDatasets'
    | 'progress'
    | 'startTime'
    | 'endTime'
    | 'estimatedTime'
    | 'errorMessage'
    | 'dataJob'
    | 'status'
    | 'timestamp'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    generation_inputs: value['generationInputs'],
    inferencer: DatasetPipelineInferencerToJSON(value['inferencer']),
    dataset: value['dataset'],
    task_name: value['taskName'],
  };
}
